<script setup lang="ts">
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const page = usePage()

const env = computed(() => page.props.app.env)
const isProduction = computed(() => env.value === 'production')
</script>

<template>
  <aside v-if="!isProduction" class="border-line bg-surface-2 mx-2 overflow-hidden rounded-lg border">
    <div class="h-0.5" :style="{ background: 'var(--gradient-brand)' }" />
    <div class="p-4">
      <div class="flex items-center gap-2">
        <span class="bg-brand-green-1 h-2 w-2 shrink-0 rounded-full" aria-hidden="true" />
        <span class="text-ink text-sm font-semibold">{{ t('title') }}</span>
        <span class="bg-surface-3 text-ink-3 ml-auto rounded px-2 py-0.5 text-xs tracking-widest uppercase">
          {{ env }}
        </span>
      </div>
    </div>
  </aside>
</template>

<i18n>
{
  "de": {
    "title": "Testumgebung",
    "hint": "Daten können jederzeit gelöscht werden."
  },
  "en": {
    "title": "Test environment",
    "hint": "Data may be deleted at any time."
  }
}
</i18n>
